import React from "react";

function ThemedSuspense() {
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      minHeight: 300, gap: 14,
    }}>
      <div style={{
        width: 40, height: 40,
        border: "3px solid #e5e7eb",
        borderTop: "3px solid #0694a2",
        borderRadius: "50%",
        animation: "spin 0.7s linear infinite",
      }} />
      <p style={{ color: "#9ca3af", fontSize: 13, margin: 0 }}>Đang tải...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default ThemedSuspense;
